import React from 'react';

import {
  Card,
  CardHeader,
  Stack,
  Divider,
  withStyles,
} from '@gogame/components';

import Actions from './Actions';
import Header from './Header';

const ScreenWidgetCart = ({
  children,
  title,
  subTitle,
  description,
  filters,
  actions,
  onSave,
  onReset,
  onClose,
  onCollapse,
  changed,
  loading,
  globalPeriod,
  editable,
  collapsed,
  affix,
  classes,
}) => {
  const [collapsedCart, setCollapsedCart] = React.useState(collapsed);

  const handleChangeCollapsedCart = React.useCallback(
    () =>
      setCollapsedCart((state) => {
        const nextState = !state;
        onCollapse(nextState);
        return nextState;
      }),
    [onCollapse]
  );

  return (
    <Card
      className={classes.container}
      data-cy={'widget'}
      data-cy-label={title}
    >
      <div className={classes.affix}>{affix}</div>
      <CardHeader
        title={
          <Header
            title={title}
            subTitle={subTitle}
            description={description}
            filters={filters}
            globalPeriod={globalPeriod}
          />
        }
        disableTypography={true}
        action={
          <Stack direction={'row'} spacing={1}>
            {actions}
            <Actions
              loading={loading}
              changed={changed}
              editable={editable}
              onSave={onSave}
              onReset={onReset}
              onRemove={onClose}
              collapsedCart={collapsedCart}
              onChangeCollapsedCart={handleChangeCollapsedCart}
            />
          </Stack>
        }
      />
      {!collapsedCart ? (
        <React.Fragment>
          <Divider />
          {children}
        </React.Fragment>
      ) : null}
    </Card>
  );
};

const styles = () => ({
  container: {
    position: 'relative',
    overflow: 'visible',
  },
  affix: {
    position: 'absolute',
    left: '0',
    top: '0',
  },
});

export default withStyles(styles)(ScreenWidgetCart);
